import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from '@shared/services';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gstar-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);

  isManualLoading: Observable<boolean>;

  isHttpRequestLoading: Observable<boolean>;

  constructor() {
    this.isManualLoading = this.loaderService.isManualLoading;
    this.isHttpRequestLoading = this.loaderService.isHttpRequestLoading;
  }
}
